import { useRef } from "react";

import containerBanner from "../assets/wh3.jpg";
import WhyCard from "../components/ui/Card/WhyCard";
import ImageHeading from "../components/ui/ImageHeading";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { ExpandableContent } from "../components/shared/ExpandableContent";
import useAxiosPublic from "../hooks/useAxiosPublic";
import { useQuery } from "@tanstack/react-query";
import LoadingPage from "../components/Layout/LoadingPage";
// const cardData = [
//   {
//     title: "Unique Single-Benefactor Model",
//     details:
//       "ZUMS is uniquely supported by the Zubaidur & Nargis Rahman Foundation (ZNRF), ensuring long-term stability and a focus on educational excellence rather than profit. This distinctive model sets ZUMS apart from many other private universities in Bangladesh.",
//   },
//   {
//     title: "Commitment to Social Impact",
//     details:
//       "As a not-for-profit institution with a social-service oriented character, ZUMS is dedicated to making a positive impact on the community. This is demonstrated by their commitment to providing free education to 10% of their student body from disadvantaged backgrounds.",
//   },
//   {
//     title: "Focus on Global Readiness",
//     details:
//       "ZUMS offers meticulously designed programs and attracts internationally recognized academics and researchers to prepare students for the complexities of today's interconnected world.",
//   },
//   {
//     title: "Emphasis on Ethical Leadership and Service",
//     details:
//       "ZUMS fosters a culture of service, social justice, and ethical leadership, shaping graduates who are not only academically proficient but also responsible and engaged citizens.",
//   },
//   {
//     title: "Student-Centered Approach",
//     details:
//       "ZUMS prioritizes the student experience, providing comprehensive support for academic, cultural, and personal development.",
//   },
//   {
//     title: "Inclusive and Welcoming Environment",
//     details:
//       "ZUMS embraces diversity and fosters a welcoming and inclusive campus environment where everyone feels a sense of belonging.",
//   },
//   {
//     title: "Core Values Driving Excellence",
//     details:
//       "Our institutional values—integrity, diversity, responsibility, service, and excellence—foster a nurturing environment that empowers students to achieve personal and professional success.",
//   },
// ];

gsap.registerPlugin(ScrollTrigger);

const WhyChooseZums2 = () => {
  const headerRef = useRef(null);

  const axiosPublic = useAxiosPublic();

  const {
    data: whyChooseZums,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["why"],
    queryFn: async () => {
      const res = await axiosPublic.get("/why-choose-zums");
      return res?.data?.data;
    },
  });

  console.log(whyChooseZums, "data");
  useGSAP(() => {
    gsap.to(headerRef.current, {
      scrollTrigger: {
        trigger: headerRef.current,
        start: "top 15%",
        end: "bottom -120%",
        pin: true,
        // markers: true,
        pinSpacing: true,
        scrub: 1,
      },
    });

    // Refresh ScrollTrigger after mounting
    ScrollTrigger.refresh();
  }, []);
  const firstHalf = whyChooseZums?.why_choose_zums?.points?.slice(
    0,
    Math.ceil(whyChooseZums?.why_choose_zums?.points.length / 2)
  );
  const secondHalf = whyChooseZums?.why_choose_zums?.points?.slice(
    Math.ceil(whyChooseZums?.why_choose_zums?.points.length / 2)
  );
  if (isLoading) {
    return <LoadingPage />;
  }

  if (error) {
    return (
      <div className="text-center py-20 text-red-500">Error loading data</div>
    );
  }
  return (
    <div>
      <ImageHeading
        heading={whyChooseZums?.hero?.title}
        imageUrl={whyChooseZums?.hero?.media_url}
      />
      <div
        style={{
          backgroundImage: `url(${containerBanner})`,
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          backgroundSize: "cover",
        }}
        className="relative"
      >
        {/* Dark Overlay */}
        <div className="absolute inset-0 z-0 bg-black opacity-70"></div>

        <div className="container relative z-10 px-6 py-10 mx-auto lg:px-8">
          <div className="grid items-start grid-cols-1 gap-16 lg:grid-cols-6 ">
            <div
              ref={headerRef}
              className="col-span-6 text-xl text-white lg:col-span-2"
            >
              <h1 className="text-3xl font-bold font-domine lg:text-4xl ">
                {whyChooseZums?.why_choose_zums?.title}
              </h1>
              <ExpandableContent
                content={whyChooseZums?.why_choose_zums?.description}
              />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 col-span-6 lg:col-span-4 border-[#AC0D30] gap-8 lg:gap-16 lg:border-l-2 xl:px-24 lg:px-16 ">
              {/* First Column */}
              <div className="flex flex-col gap-8 lg:gap-16">
                {firstHalf.map((card, index) => (
                  <WhyCard
                    key={index}
                    title={card?.title}
                    details={card?.description}
                  />
                ))}
              </div>
              {/* Second Column */}
              <div className="flex flex-col gap-8 mt-16 lg:gap-16">
                {secondHalf.map((card, index) => (
                  <WhyCard
                    key={index}
                    title={card?.title}
                    details={card?.description}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyChooseZums2;
